import React from "react";

const Actor = (props) => {
    const { actor, onClickActor, type } = props;

    // Utilise "profile_path" pour les acteurs et "poster_path" pour les films
    const imageSrc = type === "actor"
        ? `https://image.tmdb.org/t/p/original${actor.profile_path}`
        : `https://image.tmdb.org/t/p/w500${actor.poster_path}`;


    return (
        <div className="actor" onClick={onClickActor}>
            <img src={imageSrc} alt={actor.original_name} />
            <div className="actorContainer">
                <ul>
                    <li className="actorName">{actor.original_name}</li>
                </ul>
            </div>
        </div>
    );
};

export default Actor;
